import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { request } from "@/lib/request";
import { Template } from "@/lib/types";
import { useUser } from "../useUserProvider";

type UseGetTemplateOptions = Omit<
  UseQueryOptions<Template, Error>,
  "queryKey" | "queryFn"
> & {
  templateId: string;
};

export const useGetTemplate = ({
  templateId,
  enabled = true,
  ...options
}: UseGetTemplateOptions) => {
  const { accessToken } = useUser();

  return useQuery({
    ...options,
    queryKey: ["template", accessToken, templateId],
    enabled: !!accessToken && !!templateId && enabled,
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("You need to be logged in to view templates.");
      }

      const res = await request
        .get<{ data: Template }>(`/templates/${templateId}`)
        .catch(err => {
          throw new Error(
            err.response?.data.message
              ? err.response?.data.message
              : "Failed to fetch template details.",
          );
        });

      return res.data.data;
    },
  });
};
